"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.QASearchSource = void 0;
/**
 * QA搜索模式
 */
var QASearchSource;
(function (QASearchSource) {
    QASearchSource["ALL"] = "all";
    QASearchSource["SPACE"] = "space";
    QASearchSource["SUBSCRIBE"] = "subscribe";
    QASearchSource["AI_MODEL"] = "aiModel";
    QASearchSource["HELP"] = "help";
    QASearchSource["NONE"] = "none";
})(QASearchSource = exports.QASearchSource || (exports.QASearchSource = {}));
